import { Mutation } from '@varo/graphql-schema-types';
import { useRouter } from 'expo-router';
import ToggleSafeCreditBuilder from 'services/graphql/mutations/Believe/ToggleSafeCreditBuilder';
import { useDefaultErrorStrings } from 'shared/hooks/errorFormatters/useDefaultError/useDefaultErrorStrings';
import { ErrorScreenType } from 'shared/patterns/vxl/errors/ErrorScreen/ErrorScreen';
import { useMutation } from 'urql';

export interface ToggleSafePayResponse {
  data: {
    toggleSafePay: {
      message: string;
    };
  };
}

export const useToggleSafePay = () => {
  const router = useRouter();
  const [mutationResult, executeMutation] = useMutation<Mutation>(
    ToggleSafeCreditBuilder,
  );
  const {
    fetching: mutationFetching,

    data: mutationData,
    error: mutationError,
  } = mutationResult;
  const toggleSafePay = (enabled: boolean) => {
    void executeMutation({
      input: {
        enabled,
      },
    });
  };

  const { defaultTitle, defaultMessage, cancelButtonTitle } =
    useDefaultErrorStrings();

  const cancel = () => {
    router.back();
  };
  const buttons = {
    primaryButton: {
      title: cancelButtonTitle,
      onPress: cancel,
    },
  };

  const errorModel = mutationError?.message
    ? {
        screenType: ErrorScreenType.Error,
        messageHeadline: defaultTitle,
        messageBody: mutationError.message ?? defaultMessage,
        ...buttons,
      }
    : null;

  return {
    toggleSafePay,
    loading: mutationFetching,
    response: mutationData,
    mutationError,
    errorModel,
  };
};
